export const environment = {
  version: '3.20',
  production: false,
  environmentName: 'development',
  posthog: {
    enabled: false,
    apiKey: 'phc_4vGwu24xE7Whf4FIJ5tz9AcERHv7MwRF1RH4k20AhtV',
    host: 'https://hyperspace.hypt.dev',
    crossSubdomainCookie: true
  },
  apiServers: {
    apiEndpointChatBot: 'https://api.bot-config.hypt.dev',
    apiEndpointFeedback: 'https://api.user-bot.hypt.dev'
  }
};
